import React from 'react';

import schedulerImage from '../../assets/images/scheduler.png';
import activityImage from '../../assets/images/activity.png';
import StyledUnAuthContainer from './UnAuthContainer.styles';

type PropsType = React.PropsWithChildren & {
  withOutRightSection?: boolean;
};

const UnAuthContainer: React.FC<PropsType> = ({ children, withOutRightSection }) => {
  return (
    <StyledUnAuthContainer>
      <div className="un-auth-container__left">
        {children}
      </div>
      {
        withOutRightSection ? null : (
          <div className="un-auth-container__right">
            {/* <img
              src={activityImage}
              alt="Skills image"
              className="right-container__picture right-container__picture--top"
            />
            <img
              src={schedulerImage}
              alt="Prices image"
              className="right-container__picture right-container__picture--bottom"
            /> */}
          </div>
        )
      }
    </StyledUnAuthContainer>
  );
};

export default UnAuthContainer;
